<template>
    <div :class="classObj" class="app-wrapper" :style="{'--current-color': theme}">
        <Sidebar v-if="!sidebar.hide" class="sidebar-container"/>
        <div class="main-container">
            <Navbar/>
            <!-- 内容区域 -->
            <el-main class="layout-main">
                <transition name="fade-transform" mode="out-in">
                    <router-view></router-view>
                </transition>
            </el-main>
        </div>
    </div>
</template>

<script>
import Sidebar from './components/Sidebar'
import Navbar from './components/Navbar.vue'
import {mapState} from 'vuex'

export default {
    name: 'LayOut',
    components: {
        Navbar,
        Sidebar,
    },
    computed: {
        ...mapState({
            theme: state => state.settings.theme,
            sidebar: state => state.settings.sidebar,
            fixedHeader: state => state.settings.fixedHeader
        }),
        classObj() {
            return {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
            }
        },
    }
}
</script>

<style lang="scss">
@import "~@/styles/element-variables.scss";
@import "~@/styles/sidebar.scss";

.app-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    background-color: #f7fafc;

    .main-container {
        display: flex;
        flex-direction: column;
        flex: 1;
        min-width: 0;
        transition: margin-left .28s;

        .layout-main {
            padding: 15px;
        }
    }


    &.mobile.openSidebar {
        position: fixed;
        top: 0;
    }
}

.drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
}

.fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$base-sidebar-width});
    transition: width 0.28s;
}

.hideSidebar .fixed-header {
    width: calc(100% - 64px);
}

.sidebarHide .fixed-header {
    width: 100%;
}

.mobile .fixed-header {
    width: 100%;
}

/* fade */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.14s;
}

.fade-enter,
.fade-leave-active {
    opacity: 0;
}

/* fade-transform */
.fade-transform--move,
.fade-transform-leave-active,
.fade-transform-enter-active {
    transition: all .25s;
}

.fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
}

.fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
</style>
